const WIDE_VER_RENDITION = ':Wide-Ver';

function appendFitConstrain(url: string): string {
  if (/[?&]fit=constrain(?:&|$)/i.test(url)) return url;
  return url.includes('?') ? `${url}&fit=constrain` : `${url}?fit=constrain`;
}

/**
 * Appends Scene7 wide-vertical rendition to an image service URL when missing,
 * and adds `fit=constrain` for consistent scaling (matches chat preview panel).
 * Skips adding `:Wide-Ver` if the path already includes a rendition suffix (e.g. :Wide-Hor);
 * still appends `fit=constrain` when absent.
 */
export function buildScene7WideVerUrl(assetPath: string | null | undefined): string | null {
  const trimmed = assetPath?.trim();
  if (!trimmed) return null;

  const [pathPart, ...queryParts] = trimmed.split('?');
  const query = queryParts.length > 0 ? queryParts.join('?') : undefined;

  const lastSlash = pathPart.lastIndexOf('/');
  const lastSegment = lastSlash >= 0 ? pathPart.slice(lastSlash + 1) : pathPart;
  if (lastSegment.includes(':')) {
    return appendFitConstrain(trimmed);
  }

  const withRendition = `${pathPart}${WIDE_VER_RENDITION}`;
  const withQuery = query !== undefined ? `${withRendition}?${query}` : withRendition;
  return appendFitConstrain(withQuery);
}
